import { toRef } from 'vue'
import { useStore } from 'vuex'
import InStockLabel from '../InStockLabel/InStockLabel.vue'

export default {
    name: "TableComponentGeneric",
    props: {
        tableData: {
            required: true,
            type: Object
        }
    },
    components: {
        InStockLabel
    },
    setup(props){

        const store = useStore()

        const isCellValueAButton = (cellValue) => typeof cellValue === 'object' && cellValue.href !== undefined
        const isCellValueAnInputField = (cellValue) => typeof cellValue === 'object' && cellValue.value !== undefined
        const isCellValueAStockLabel = (cellValue) => typeof cellValue === 'object' && cellValue.inStock !== undefined

        const determineButtonColor = (color) => {
            const buttonColorDict = {
                'black' : 'nlx-button--black',
                'green' : 'nlx-button--confirm',
                'blue' : ''
            }
            return buttonColorDict[color] 
        }

        const getLabel = (labelRequested) => store.getters['labels/getLabel'](labelRequested)

        const tableData = toRef(props, 'tableData')
        
        return {
            getLabel,
            determineButtonColor,
            isCellValueAButton,
            isCellValueAnInputField,
            isCellValueAStockLabel,
            tableData
        }
    }
}